import {
    pharmacy_sms_conversation_list,
    pharmacy_serach_patient,
    pharmacy_sms_add_conversation,
    pharmacy_sms_get_conversation_messages,
    pharmacy_sms_send_message,

} from '../../../../networking/urlEndPoints';
import { showToast } from '../../../../utils/helper/helper';

import Axios from '../../../../networking/intraceptor';

// Action Types
const PHARMACY_SMS_CONVERSATION_LISTT_REQUEST = 'PHARMACY_SMS_CONVERSATION_LISTT_REQUEST';
const PHARMACY_SMS_CONVERSATION_LISTT_SUCCESS = 'PHARMACY_SMS_CONVERSATION_LISTT_SUCCESS';
const PHARMACY_SMS_CONVERSATION_LISTT_FAILURE = 'PHARMACY_SMS_CONVERSATION_LISTT_FAILURE';

const PHARMACY_ADD_DATA_REQUEST = 'PHARMACY_ADD_DATA_REQUEST';
const PHARMACY_ADD_DATA_SUCCESS = 'PHARMACY_ADD_DATA_SUCCESS';
const PHARMACY_ADD_DATA_FAILURE = 'PHARMACY_ADD_DATA_FAILURE';

const PHARMACY_CURRENT_CONVERSATION_USER = 'PHARMACY_CURRENT_CONVERSATION_USER';

const PHAMACY_GET_CONVERSATION_MESSAGES_REQUEST = 'PHAMACY_GET_CONVERSATION_MESSAGES_REQUEST';
const PHAMACY_GET_CONVERSATION_MESSAGES_SUCCESS = 'PHAMACY_GET_CONVERSATION_MESSAGES_SUCCESS';
const PHAMACY_GET_CONVERSATION_MESSAGES_FAILURE = 'PHAMACY_GET_CONVERSATION_MESSAGES_FAILURE';

const REMOVE_CONVERSATION_MESSAGES_REQUEST = 'REMOVE_CONVERSATION_MESSAGES_REQUEST';

const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

// Add this constant for localStorage key
const CURRENT_CONVERSATION_ID_KEY = 'pharmacy_current_conversation_id';

const pharmacySmsConversationListRequest = (requestType) => {
    return {
        type: PHARMACY_SMS_CONVERSATION_LISTT_REQUEST,
        payload: {
            requestType: requestType
        }
    }
}


const pharmacySmsConversationListSuccess = (requestType, data) => {
    return {
        type: PHARMACY_SMS_CONVERSATION_LISTT_SUCCESS,
        payload: {
            requestType: requestType,
            data: data
        }
    }
}

const pharmacySmsConversationListFailure = (requestType, error) => {
    return {
        type: PHARMACY_SMS_CONVERSATION_LISTT_FAILURE,
        payload: {
            requestType: requestType,
            error: error
        }
    }
}

const pharmacyAddDataRequest = (requestType) => {
    return {
        type: PHARMACY_ADD_DATA_REQUEST,
        payload: {
            requestType: requestType
        }
    }
}

const pharmacyAddDataSuccess = (requestType, data) => {
    return {
        type: PHARMACY_ADD_DATA_SUCCESS,
        payload: {
            requestType: requestType,
            data: data
        }
    }
}

const pharmacyAddDataFailure = (requestType, error) => {
    return {
        type: PHARMACY_ADD_DATA_FAILURE,
        payload: {
            requestType: requestType,
            error: error
        }
    }
}

const pharmacyGetConversationMessagesRequest = (requestType) => {
    return {
        type: PHAMACY_GET_CONVERSATION_MESSAGES_REQUEST,
        payload: {
            requestType: requestType
        }
    }
}

const pharmacyGetConversationMessagesSuccess = (requestType, data, append = false) => {
    return {
        type: PHAMACY_GET_CONVERSATION_MESSAGES_SUCCESS,
        payload: {
            requestType: requestType,
            data: data,
            append: append
        }
    }
}

const pharmacyGetConversationMessagesFailure = (requestType, error) => {
    return {
        type: PHAMACY_GET_CONVERSATION_MESSAGES_FAILURE,
        payload: {
            requestType: requestType,
            error: error
        }
    }
}

export const pharmacyCurrentConversationUser = (requestType, data) => {
    // Capitalize the name if it exists
    if (data && data.name) {
        data.name = data.name.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    return {
        type: PHARMACY_CURRENT_CONVERSATION_USER,
        payload: {
            requestType: requestType,
            data: data
        }
    }
}

// Function to get the stored conversation ID
export const getStoredConversationId = () => {
    return localStorage.getItem(CURRENT_CONVERSATION_ID_KEY);
}

// Function to clear the stored conversation ID
export const clearStoredConversationId = () => {
    localStorage.removeItem(CURRENT_CONVERSATION_ID_KEY);
}

export const fetchPharmacySmsConversationList = ({ requestType, search, setPatientList }) => {
    return async (dispatch) => {
        try {
            dispatch(pharmacySmsConversationListRequest(requestType));

            const params = search ? `?search=${search}` : '';
            const response = await Axios.get(`${pharmacy_sms_conversation_list}${params}`);

            if (response.status === 200) {
                dispatch(pharmacySmsConversationListSuccess(requestType, response.data));

                // Check if we need to load a specific conversation after loading the list
                const storedConversationId = getStoredConversationId();
                if (storedConversationId && response.data?.data?.data) {
                    // Find the conversation in the loaded list
                    const foundConversation = response.data.data.data.find(
                        convo => convo.id.toString() === storedConversationId.toString()
                    );

                    if (foundConversation) {
                        // Set as current conversation user
                        dispatch(pharmacyCurrentConversationUser('loadStoredConversation', foundConversation));

                        // Load messages for this conversation
                        dispatch(handleGetConversationMessages({
                            requestType: 'pharmacyGetConversationMessages',
                            requestData: {
                                threadId: foundConversation.id
                            },
                            page: 1,
                            append: false
                        }));
                    }
                }

                if (response?.data?.data?.data?.length === 0 && search && typeof setPatientList === 'function') {
                    dispatch(fetch_WINRX_PatientList({ setPatientList, search: search }));
                }
            }
        } catch (error) {
            dispatch(pharmacySmsConversationListFailure(requestType, error.response));
        }
    };
};

export const handleAddConversation = ({ requestType, requestData, setShowFields }) => {
    return async (dispatch) => {
        try {
            dispatch(pharmacyAddDataRequest(requestType));

            const response = await Axios.post(pharmacy_sms_add_conversation, requestData);
            if (response.status === 200) {
                dispatch(pharmacyAddDataSuccess(requestType, response.data));
                dispatch(fetchPharmacySmsConversationList({ requestType: 'pharmacySmsConversationList', search: '' }));
                setShowFields(false);
                // Clear form data and hide input field after successful addition
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.data?.error?.phone[0] || 'Something went wrong when adding conversation try again';
            showToast(errorMessage, 'error');
            dispatch(pharmacyAddDataFailure(requestType, error.response));
        }
    };
};


export const fetch_WINRX_PatientList = ({ setPatientList, search }) => {

    return async (dispatch) => {
        try {
            setPatientList({ loading: true, data: [], error: null })
            const response = await Axios.get(`${pharmacy_serach_patient}?search=${search}`)

            if (response?.status === 200) {
                setPatientList({ loading: false, data: response?.data, error: null })
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                showToast('Something went wrong when getting patient list try again', 'error')
                setPatientList({ loading: false, data: [], error: error?.response })
            }
        }
    }
}

export const handleGetConversationMessages = ({ requestType, requestData, page = 1, append = false, setIsLoadingMore }) => {
    return async (dispatch) => {
        try {
            dispatch(pharmacyGetConversationMessagesRequest(requestType));

            // Add pagination parameters to the request 
            const paginatedRequest = {
                ...requestData,
                page: page,
                no_of_records: 200
            };

            const response = await Axios.post(pharmacy_sms_get_conversation_messages, paginatedRequest);

            if (response.status === 200) {
                dispatch(pharmacyGetConversationMessagesSuccess(requestType, response.data, append));
            }
        } catch (error) {
            dispatch(pharmacyGetConversationMessagesFailure(requestType, error.response));
        } finally {
            if (typeof setIsLoadingMore === 'function') {
                setIsLoadingMore(false);
            }
        }
    };
};

export const getInitiateChats = ({ requestType, requestData }) => {
    return async (dispatch) => {
        try {
            dispatch(pharmacyGetConversationMessagesRequest(requestType));

            const response = await Axios.post(pharmacy_sms_get_conversation_messages, requestData);

            if (response.status === 200) {
                dispatch(pharmacyGetConversationMessagesSuccess(requestType, response.data));
            }
        } catch (error) {
            dispatch(pharmacyGetConversationMessagesFailure(requestType, error.response));
        }
    };
};


export const sendPatientMessage = (messageData) => async (dispatch) => {

    // Validate required fields
    if (!messageData?.thread_id || !messageData?.message) {
        dispatch({
            type: SEND_MESSAGE_FAILURE,
            payload: "thread_id and message are required.",
        });
        return;
    }

    try {
        dispatch({ type: SEND_MESSAGE_REQUEST });

        // Create a temporary message with current timestamp for optimistic UI update
        // const tempMessage = {
        //     id: `temp-${Date.now()}`,
        //     thread_id: messageData.thread_id,
        //     message: messageData.message,
        //     sender_type: 'pharmacy',
        // };


        // Actually send to server
        const {  data } = await Axios.post(pharmacy_sms_send_message, messageData);

        // Update with actual message data from server if available
        if (data && data.data) {
            dispatch({
                type: SEND_MESSAGE_SUCCESS,
                payload: {
                    data: data.data
                }
            });
        }

    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || "Something went wrong";
        dispatch({
            type: SEND_MESSAGE_FAILURE,
            payload: errorMessage,
        });

        throw error; // Re-throw to allow calling code to handle the error
    }
};

export const removeConversationMessagesRequest = (requestType) => {
    return {
        type: REMOVE_CONVERSATION_MESSAGES_REQUEST,
        payload: { requestType }
    }
}





// Initial State
const initialState = {
    conversationList: {
        loading: false,
        data: null,
        error: null,
        requestType: null,
    },
    addConversation: {
        loading: false,
        data: null,
        error: null,
        requestType: null,
    },
    currentConversationUser: {
        loading: false,
        data: null,
        error: null,
        requestType: null,
    },
    conversationMessages: {
        loading: false,
        data: null,
        allMessages: [],
        error: null,
        requestType: null,
    },
    sendMessage: {
        loading: false,
        success: false,
        error: null,
        requestType: null,
    }


};

// Reducer
const pharmacySmsReducer = (state = initialState, action) => {
    switch (action.type) {

        //Pharmacy SMS Conversation List
        case PHARMACY_SMS_CONVERSATION_LISTT_REQUEST:
            return {
                ...state,
                conversationList: {
                    loading: true,
                    // data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case PHARMACY_SMS_CONVERSATION_LISTT_SUCCESS:
            return {
                ...state,
                conversationList: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: action.payload.data
                }
            };
        case PHARMACY_SMS_CONVERSATION_LISTT_FAILURE:
            return {
                ...state,
                conversationList: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Pharmacy Add Conversation
        case PHARMACY_ADD_DATA_REQUEST:
            return {
                ...state,
                addConversation: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload?.requestType || null,
                }
            };
        case PHARMACY_ADD_DATA_SUCCESS:
            return {
                ...state,
                addConversation: {
                    loading: false,
                    error: null,
                    requestType: action.payload?.requestType || null,
                    data: action.payload?.data || action.payload
                }
            };
        case PHARMACY_ADD_DATA_FAILURE:
            return {
                ...state,
                addConversation: {
                    loading: false,
                    data: null,
                    error: action.payload?.error || action.payload || null,
                    requestType: action.payload?.requestType || null,
                }
            };

        //Pharmacy Current Conversation User
        case PHARMACY_CURRENT_CONVERSATION_USER:
            return {
                ...state,
                currentConversationUser: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        //Pharmacy Conversation Messages
        case REMOVE_CONVERSATION_MESSAGES_REQUEST:
            return {
                ...state,
                conversationMessages: {
                    ...state.conversationMessages,
                    allMessages: [],
                    pagination: {
                        currentPage: 1,
                        lastPage: 1,
                        total: 0,
                        hasMore: false
                    }
                }
            };
        case PHAMACY_GET_CONVERSATION_MESSAGES_REQUEST:
            return {
                ...state,
                conversationMessages: {
                    ...state.conversationMessages,
                    // loading: state.conversationMessages?.hasMore ? false : true,
                    error: null,
                    requestType: action.payload.requestType,
                    // Only clear messages if not appending
                    // ...(state.conversationMessages && action.payload.append ? {} : { allMessages: [] })
                    // allMessages: state.conversationMessages?.hasMore ? state.conversationMessages?.allMessages : []
                }
            };
        case PHAMACY_GET_CONVERSATION_MESSAGES_SUCCESS:
            // Handle pagination by either replacing messages or appending to existing ones
            const newMessages = action.payload.data?.data?.data || [];
            const existingMessages = action.payload.append ?
                (state.conversationMessages?.allMessages || []) : [];

            // When appending older messages (loading previous pages), add them at the beginning
            // When loading initial messages, just use them directly
            const combinedMessages = action.payload.append ?
                [...newMessages, ...existingMessages] : // Older messages go at the beginning
                newMessages;
            // console.log(action.payload.data.data.pagination);
            const pagination = action.payload.data?.data?.pagination;
            // console.log(pagination);
            return {
                ...state,
                conversationMessages: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: action.payload.data,
                    allMessages: combinedMessages,
                    pagination: {
                        currentPage: pagination?.current_page || 1,
                        lastPage: pagination?.last_page || 1,
                        total: pagination?.total || 0,
                        hasMore: (pagination?.current_page || 1) <= (pagination?.last_page || 1)
                    }
                }
            };
        case PHAMACY_GET_CONVERSATION_MESSAGES_FAILURE:
            return {
                ...state,
                conversationMessages: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                    allMessages: []
                }
            };

        case SEND_MESSAGE_REQUEST:
            return {
                ...state,
                sendMessage: {
                    loading: true,
                    success: false,
                    error: null,
                    requestType: action.payload?.requestType || null,
                }
            };

        case SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                sendMessage: {
                    loading: false,
                    success: true,
                    error: null,
                    requestType: action.payload?.requestType || null,
                    data: action.payload.data
                },
                conversationMessages: {
                    ...state.conversationMessages,
                    allMessages: state.conversationMessages?.allMessages
                        ? [...state.conversationMessages.allMessages, action.payload.data] // New message goes at the end
                        : [action.payload.data]
                }
            };

        case SEND_MESSAGE_FAILURE:
            return {
                ...state,
                sendMessage: {
                    loading: false,
                    success: false,
                    error: action.payload,
                    requestType: action.payload?.requestType || null,
                }
            };
        default:
            return state;
    }
}

export default pharmacySmsReducer;